import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (consent === null) {
      setIsVisible(true);
    }
  }, []);

  const handleConsent = (consent: 'accepted' | 'declined') => {
    localStorage.setItem('cookie_consent', consent);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-astral-dark/80 backdrop-blur-xl border-t border-white/10 p-6 z-[100] animate-in fade-in slide-in-from-bottom-5">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <p className="text-sm text-slate-300 max-w-3xl leading-relaxed">
          This website uses cookies to enhance your experience and analyze our traffic. By clicking "Accept", you agree to our use of cookies. For more details, please review our{' '}
          <Link to="/cookie-policy" className="text-astral-purple hover:underline font-bold">
            Cookie Policy
          </Link>.
        </p>
        <div className="flex items-center gap-4 flex-shrink-0">
          <button
            onClick={() => handleConsent('declined')}
            className="px-6 py-2 text-xs font-bold uppercase tracking-widest text-slate-300 hover:text-white transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => handleConsent('accepted')}
            className="px-6 py-2 bg-white text-black font-bold uppercase tracking-widest text-xs hover:bg-astral-purple hover:text-white transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};